import React, { useEffect, useState } from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';
import { Tooltip } from 'react-tooltip';

import css from './IconBadge.module.css';
import { FormattedMessage } from 'react-intl';

const IconBadge = props => {
  const { className, rootClassName, isVerified } = props;
  const classes = classNames(rootClassName || css.root, className);
  const [isOpen, setIsOpen] = useState(false)

  const [isMobile, setIsMobile] = useState(false)

  const handleResize = () => {
    if (typeof window === 'object' && window.innerWidth < 768) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  // create an event listener
  useEffect(() => {
    window.addEventListener("resize", handleResize)
  })

  useEffect(() => {
    handleResize()
  }, [])

  const dataTooltipId = `${isVerified ? 'verified' : 'unverified'}-tooltip-${Math.random().toString(36).slice(2)}`;
  const tooltipContent = isVerified ? <FormattedMessage id="IconBadge.verifiedContent" /> : <FormattedMessage id="IconBadge.unverifiedContent" />;
  const tooltipLearnMore = <FormattedMessage id="IconBadge.learnMore" values={{
    link: <a
      href='https://www.parnexus.com/p/kyc_aml_dd'
      className={css.tooltipLink}
      onClick={(event) => {
        event.stopPropagation();
        // Redirect to the specified link
        window.open('https://www.parnexus.com/p/kyc_aml_dd', '_blank');
      }}
      target='_blank'
    >here</a>
  }} />
  const isMobileDisplay = isMobile ? { isOpen: isOpen } : {}

  const svgWidth = isMobile ? "10" : "13";
  const svgHeight = isMobile ? "12" : "16";

  return (
    <>
      <span id={dataTooltipId} data-tooltip-place="top" onClick={(e) => {
        e.preventDefault()
        setIsOpen(!isOpen)
      }}>
        {isVerified ? <svg className={classes} width={svgWidth} height={svgHeight} viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 0L0 2.18182V5.45455C0 9.72545 3.57722 11.7196 5 12C6.42278 11.7196 10 9.72545 10 5.45455V2.18182L5 0ZM5 1.19425L8.88889 2.89134V5.45455C8.88889 6.45581 8.64788 7.30678 8.28125 8.02202C7.41428 7.38052 5.84675 7.09091 5 7.09091C4.15323 7.09091 2.58517 7.3805 1.71875 8.02202C1.35212 7.30678 1.11111 6.45581 1.11111 5.45455V2.89134L5 1.19425ZM5 2.59091C4.00444 2.59091 3.19444 3.38618 3.19444 4.36364C3.19444 5.34109 4.00444 6.13636 5 6.13636C5.99556 6.13636 6.80556 5.34109 6.80556 4.36364C6.80556 3.38618 5.99556 2.59091 5 2.59091ZM5 3.68182C5.38278 3.68182 5.69444 3.98782 5.69444 4.36364C5.69444 4.73945 5.38278 5.04545 5 5.04545C4.61722 5.04545 4.30556 4.73945 4.30556 4.36364C4.30556 3.98782 4.61722 3.68182 5 3.68182ZM5 8.18182C6.3593 8.18182 7.20984 8.57452 7.72678 8.89879C6.85568 10.0233 5.69815 10.6636 5 10.875C4.30186 10.6636 3.14432 10.0233 2.27322 8.89879C2.79017 8.57452 3.6407 8.18182 5 8.18182Z" fill="#1D67C2" />
        </svg> : <svg className={classes} width={svgWidth} height={svgHeight} viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 0L0 2.18182V5.45455C0 9.72545 3.57722 11.7196 5 12C6.42278 11.7196 10 9.72545 10 5.45455V2.18182L5 0ZM5 1.19425L8.88889 2.89134V5.45455C8.88889 6.45581 8.64788 7.30678 8.28125 8.02202C7.41428 7.38052 5.84675 7.09091 5 7.09091C4.15323 7.09091 2.58517 7.3805 1.71875 8.02202C1.35212 7.30678 1.11111 6.45581 1.11111 5.45455V2.89134L5 1.19425ZM5 2.59091C4.00444 2.59091 3.19444 3.38618 3.19444 4.36364C3.19444 5.34109 4.00444 6.13636 5 6.13636C5.99556 6.13636 6.80556 5.34109 6.80556 4.36364C6.80556 3.38618 5.99556 2.59091 5 2.59091ZM5 3.68182C5.38278 3.68182 5.69444 3.98782 5.69444 4.36364C5.69444 4.73945 5.38278 5.04545 5 5.04545C4.61722 5.04545 4.30556 4.73945 4.30556 4.36364C4.30556 3.98782 4.61722 3.68182 5 3.68182ZM5 8.18182C6.3593 8.18182 7.20984 8.57452 7.72678 8.89879C6.85568 10.0233 5.69815 10.6636 5 10.875C4.30186 10.6636 3.14432 10.0233 2.27322 8.89879C2.79017 8.57452 3.6407 8.18182 5 8.18182Z" fill="#0DA22E" />
        </svg>}
      </span>

      <Tooltip
        className={css.mobileResponsive}
        style={{zIndex:"100"}}
        {...isMobileDisplay}
        anchorSelect={'#' + dataTooltipId} clickable>
        {(isOpen || !isMobile) && <span
          onClick={(event) => {
            event.preventDefault();
          }}
        >
          {isMobile && <div className={css.closeButton} onClick={(e) => {
            e.preventDefault()
            setIsOpen(false)
          }}>&#x2715;</div>}
          <span>
            {
              tooltipContent
            }
          </span>
          <span>
            {
              tooltipLearnMore
            }
          </span>

        </span>}
      </Tooltip >
    </>
  );
};

IconBadge.defaultProps = { className: null };

IconBadge.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconBadge;
